import React from 'react';
import { ChevronLeft, ChevronRight, Lock } from 'lucide-react';
import Filter from './Filter';
import solanaLogo from '../assets/solana-logo.png'
import CardSlider from './CardSlider';

const TokenCard = ({
  name,
  subtitle,
  liquidity,
  price,
  fdv,
  trustScore,
}) => {
  return (
    <div className="token-card">
      <div className="token-info">
        <div className="token-logo">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4" />
            <path d="M4 6v12c0 1.1.9 2 2 2h14v-4" />
            <path d="M18 12a2 2 0 0 0-2 2c0 1.1.9 2 2 2h4v-4h-4z" />
          </svg>
        </div>
        <div className="token-name">
          <span className="token-title">{name}</span>
          <span className="token-subtitle">{subtitle}</span>
        </div>
      </div>

      <div className="token-metrics">
        <div className="metric">
          <span className="metric-label">Liquidity</span>
          <span className="metric-value">{liquidity}</span>
          <Lock className="lock-icon" size={16} />
        </div>
        <div className="metric">
          <span className="metric-label">Price</span>
          <span className="metric-value">{price}</span>
        </div>
        <div className="metric">
          <span className="metric-label">FDV</span>
          <span className="metric-value">{fdv}</span>
        </div>
        <div className="trust-score">
          <span>Trust Score</span>
          <span>{trustScore}%</span>
        </div>
      </div>
    </div>
  );
};

const DEX = () => {
  return (
    <div className="dex-container">
      <div className="dex-header">
        <span>DECENTRALIZED EXCHANGE</span>
        <div className="nav-buttons">
          <button className="nav-button">
            <ChevronLeft size={20} />
          </button>
          <button className="nav-button">
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      <div className="token-list">
        <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
          <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
        <TokenCard
          name="TETHER USD"
          subtitle="Lorem ipsum dummy"
          liquidity="$60.00"
          price="$67.72M"
          fdv="$27.03M"
          trustScore={90}
        />
      </div>
    </div>
  );
};
const tableData = [
  {
    ImageName: solanaLogo,
    name: "Shiba INU (SHIB)",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "Shiba INU (SHIB)",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "Shiba INU (SHIB)",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "Shiba INU (SHIB)",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "Shiba INU (SHIB)",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "Shiba INU (SHIB)",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "Shiba INU (SHIB)",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "USDC (USDC)",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "Tron",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "Tron",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "Tron",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "Tron",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
  {
    ImageName: solanaLogo,
    name: "Tron",
    price: "$68.99",
    age: "5 days",
    txn: "2,457",
    fiveMin: "-2.457",
    oneHr: "-2.457",
    sixHr: "-2.457",
    twentyFourHr: "-2.457",
    vol: "$60.995k",
    liq: "$60.995k",
    mcap: "$60.995k",
    fdv:  '$60.9556k',
  },
];

const ListView = () => {
  return (
    <div className="invest-background">
      <Filter />

    <div className="table-container-new">
      <table className='table-table-container'>
        <thead>
          <tr>
            <th>Coin Name</th>
            <th>Price</th>
            <th>Age</th>
            <th>TXN</th>
            <th>5M</th>
            <th>1H</th>
            <th>6H</th>
            <th>24H</th>
            <th>VOL</th>
            <th>LIQ</th>
            <th>MCAP</th>
            <th>FDV</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index}>
              <td><img src ={row.ImageName} />{row.name}</td>
              <td>{row.price}</td>
              <td>{row.age}</td>
              <td>{row.txn}</td>
              <td className="negative">{row.fiveMin}</td>
              <td className="negative">{row.oneHr}</td>
              <td className="negative">{row.sixHr}</td>
              <td className="negative">{row.twentyFourHr}</td>
              <td>{row.vol}</td>
              <td>{row.liq}</td>
              <td>{row.mcap}</td>
              <td>{row.fdv}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    
    </div>
  );
};

export default ListView;